import list from 'src/modules/image/list/imageListReducers';
import form from 'src/modules/image/form/imageFormReducers';
import view from 'src/modules/image/view/imageViewReducers';
import destroy from 'src/modules/image/destroy/imageDestroyReducers';
import importerReducer from 'src/modules/image/importer/imageImporterReducers';
import { combineReducers } from 'redux';

export default combineReducers({
  list,
  form,
  view,
  destroy,
  importer: importerReducer,
});
